import type { Experience } from '@axiom/validation';
import orderBy from 'lodash/orderBy';

export const ExperienceUtil = {
  orderExperiencesForDisplay(experiences: Experience[]) {
    return orderBy(
      experiences,
      ['endDate', 'startDate', 'isAxiom'],
      ['desc', 'desc', 'desc']
    );
  },
};
